import { catchError, finalize, tap, throwError } from 'rxjs';

import { AuthService } from './auth-service';
import { HttpInterceptorFn } from '@angular/common/http';
import { LoaderService } from './loader-service';
import { ToastService } from './toast-service';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';

let pendingRequests = 0;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastService = inject(ToastService);
  const loaderService = inject(LoaderService);
  let token = authService.isLoggedIn() ? sessionStorage.getItem('token') : null;
  let twoFA = authService.isLoggedIn() ? sessionStorage.getItem('twoFA') : null;

  if (environment.setHeaderToken && token) {
    let headers: Record<string, string> = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-Native': 'True'
    };
    if (req?.url?.includes('pg') && !req?.url?.includes('gateway')) {
      let item: any = JSON.parse(sessionStorage.getItem('pgTokens') || '{}');
      if (item) {
        headers['X-PG-KEY'] = item['X-PG-KEY']
        headers['X-PG-TOKEN'] = item['X-PG-TOKEN']
        delete headers['Authorization']
      }
    }
    else if (req?.url?.includes('gateway')) {
      let item: any = JSON.parse(sessionStorage.getItem('pgTokens') || '{}');
      if (item) {
        delete headers['X-PG-KEY']
        delete headers['X-PG-TOKEN']
        delete headers['Authorization']
        delete headers['X-Native']
      }
    }
    else if (twoFA && !req?.url?.includes('gateway')) {
      headers['X-2FA'] = `${twoFA}`;
    }
    else {

    }

    req = req.clone({
      setHeaders: headers
    });
  }

  // if (environment.setHeaderToken && token) {
  //   req = req.clone({
  //     setHeaders: {
  //       'Authorization': `Bearer ${token}`,
  //       'Content-Type': 'application/json',
  //       'X-Native': 'True'
  //     }
  //   });
  // }

  pendingRequests++;
  loaderService.show();

  return next(req).pipe(
    tap({
      next: () => { },
      error: (error) => {
        if (error.status == '404') {
          toastService.showError(error.error?.message || 'Unauthorized access');
          // window.location.href = 'error/404';
        }
        else if (error.status == '401') {
          toastService.showError('Session expired');
          window.location.href = 'user/unauthorized';
        }
        else {
          let errorMessage = 'Something went wrong!';
          if (error?.error?.message) {
            if (typeof error.error.message === 'string') {
              errorMessage = error.error.message || error.message;
              console.log(errorMessage, '---')
            }
            else if (Array.isArray(error.error.message)) {
              errorMessage = error.error.message.join(' ');
            }
            else if (typeof error.error.message === 'object') {
              const messages = Object.values(error.error.message)
                .filter(val => Array.isArray(val))
                .map(arr => (arr as string[]).join(' '))
                .join(' ');
              if (messages) {
                errorMessage = messages;
              }
            }
          }

          else if (error.message) {
            errorMessage = error.message;
          }

          toastService.showError(errorMessage);
        }
      }
    }),
    catchError((error) => throwError(() => error.error.message || error.message || 'Something went wrong!')),
    finalize(() => {
      pendingRequests--;
      if (pendingRequests === 0) {
        loaderService.hide();
      }
    })
  );
};
